export const generatePieChartData = (
  data: Record<string, number>,
  labels?: Record<string, string>,
) => {
  return Object.keys(data).map((key) => ({
    name: (labels && labels[key]) || key,
    value: data[key],
  }));
};

export const generateTopNData = (
  data: Record<string, number>,
  n = 5,
  labels?: Record<string, string>,
) => {
  return Object.keys(data)
    .sort((a, b) => data[b] - data[a])
    .slice(0, n)
    .map((key) => ({
      label: (labels && labels[key]) || key,
      value: data[key],
    }));
};

export const generateBarChartData = (
  data: Record<string, number>,
  labels?: Record<string, string>,
) => {
  return Object.entries(data)
    .map(([label, count]) => ({
      date: labels?.[label] || label,
      "Aantal afspraken": count,
    }))
    .sort((a, b) => b["Aantal afspraken"] - a["Aantal afspraken"]);
};

export const getBarChartDataKeys = (_data: Record<string, number>) => {
  return ["Aantal afspraken"];
};
